export const _LOAD_MODEL_ = 'Load:Magazine';
export const _SAVE_MODEL_ = 'Save:Magazine';
export const _DELETE_MAGAZINE_ = 'Delete:Magazine';
export const MODEL_MAGAZINE_STATUS = 'MODEL_MAGAZINE_STATUS';
export const ATTACHED = 'attached';
export const DETACHED = 'detached';

export const PUZZLE_ROW = {
  id: null,
  name: null,
};

export const MODEL = {
  id: null,
  name: '',
  slug: '',
  price: null,
  image: '',
  type_id: null,
  status_id: 1,
  description: null,
  status: {
    name: 'Rascunho',
    slug: 'draft',
  },
  published_date: null,
  puzzles: [{ ...PUZZLE_ROW }],
};
